import { render, staticRenderFns } from "./MasterEditor.vue?vue&type=template&id=652edaca&scoped=true&"
import script from "./MasterEditor.vue?vue&type=script&lang=js&"
export * from "./MasterEditor.vue?vue&type=script&lang=js&"
import style0 from "./MasterEditor.vue?vue&type=style&index=0&id=652edaca&scoped=true&lang=css&"
import style1 from "./MasterEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652edaca",
  null
  
)

export default component.exports